import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Header() {
  const { user, logout, isAdmin } = useAuth();
  const location = useLocation();

  return (
    <header className="header">
      <h1>📅 Beschikbaarheid Agenda</h1>
      
      <nav className="header-nav">
        {isAdmin ? (
          <>
            <Link 
              to="/admin" 
              style={{ 
                background: location.pathname === '/admin' ? 'rgba(255,255,255,0.3)' : undefined 
              }}
            >
              Beheren
            </Link>
            <Link 
              to="/agenda"
              style={{ 
                background: location.pathname === '/agenda' ? 'rgba(255,255,255,0.3)' : undefined 
              }}
            >
              School Weergave
            </Link>
          </>
        ) : null}
        
        <span style={{ opacity: 0.8, fontSize: '0.9rem' }}>
          {user?.schoolName || user?.email}
        </span>
        
        <button onClick={logout}>Uitloggen</button>
      </nav>
    </header>
  );
}
